export const generateSubcomponentDataBy = function (sub, question_code = null) {
    // 아래 JSON.parse(JSON.stringify(sub)) 는 sub 가 undefined 일 때
    // JSON.stringify 가 undefined 를 반환해 `SyntaxError: "undefined" is not valid JSON` 으로 죽는다.
    // 원인 추적이 어려운 형태라, 잘못된 입력임을 호출 지점에서 바로 알 수 있게 명시적으로 던진다.
    if (!sub) {
        throw new TypeError('generateSubcomponentDataBy: sub 가 비어 있습니다 (호출측에서 빈 응답 여부를 먼저 확인하세요)')
    }

    let {
        sub_init_id, sub_id,
        company_id, company_name, campaign_id,
        sub_code, sub_type,
        sub_name, sub_name_e, sub_name_c,
        sub_name_ea, sub_name_ca,
        sub_description, sub_description_e, sub_description_c,
        sub_description_ea, sub_description_ca,
        sub_info, sub_info_e, sub_info_c,
        sub_info_ea, sub_info_ca,
        sub_condition,
        sub_data_header, sub_data_contents,
        sub_priority, sub_child, sub_parent,
        risk, tags, has_pipeline, label
    } = JSON.parse(JSON.stringify(sub))
    
    sub_init_id = isFieldEmpty(sub_init_id) ? null : Number(sub_init_id)
    sub_id = isFieldEmpty(sub_id) ? null : Number(sub_id)
    company_id = isFieldEmpty(company_id) ? null : Number(company_id)
    company_name = isFieldEmpty(company_name) ? null : company_name
    campaign_id = isFieldEmpty(campaign_id) ? null : Number(campaign_id)

    sub_name_e = isFieldEmpty(sub_name_e) && isFieldEmpty(sub_name_ea) ? null : sub_name_ea || sub_name_e
    sub_name_c = isFieldEmpty(sub_name_c) && isFieldEmpty(sub_name_ca) ? null : sub_name_ca || sub_name_c
    sub_description_e = isFieldEmpty(sub_description_e) && isFieldEmpty(sub_description_ea) ? null : sub_description_ea || sub_description_e
    sub_description_c = isFieldEmpty(sub_description_c) && isFieldEmpty(sub_description_ca) ? null : sub_description_ca || sub_description_c
    sub_info_e = isFieldEmpty(sub_info_e) && isFieldEmpty(sub_info_ea) ? null : sub_info_ea || sub_info_e
    sub_info_c = isFieldEmpty(sub_info_c) && isFieldEmpty(sub_info_ca) ? null : sub_info_ca || sub_info_c

    sub_name_e = isFieldEmpty(sub_name_e) ? null : sub_name_e
    sub_name_c = isFieldEmpty(sub_name_c) ? null : sub_name_c
    sub_description_e = isFieldEmpty(sub_description_e) ? null : sub_description_e
    sub_description_c = isFieldEmpty(sub_description_c) ? null : sub_description_c
    sub_info_e = isFieldEmpty(sub_info_e) ? null : sub_info_e
    sub_info_c = isFieldEmpty(sub_info_c) ? null : sub_info_c
    label = isFieldEmpty(label) ? null : label

    has_pipeline = Boolean(has_pipeline)
    
    tags = isFieldEmpty(tags)
        ? []
        : typeof tags === 'object' && Array.isArray(tags)
            ? tags
            : tags.split(',')
    risk = typeof risk === 'undefined' ? false : risk
    sub_data_contents = typeof sub_data_contents === 'string' ? JSON.parse(sub_data_contents) : sub_data_contents
    sub_condition = isFieldEmpty(sub_condition) ? { text: '' } : typeof sub_condition === 'string' ? JSON.parse(sub_condition) : sub_condition

    if (sub_type === "table") {
        const table_header = sub_data_contents.table_header
        sub_data_contents.structure = sub_data_contents.structure.reduce((_structure, _str_row) => {
            if (table_header) {
                // 세 키는 행마다 있다는 보장이 없다. 신규 문항 기본값이나 버전 복사로 만들어진 행에는
                // 아예 없어서, 방어 없이 접근하면 저장 경로 첫 줄에서 TypeError 가 난다
                // (2026-09-04 ST4v2 prod 사고 — 요청조차 나가지 못했다).
                // 같은 데이터를 그리는 EditingDFTable.vue 템플릿도 동일하게 방어한다.
                const _dropdown = _str_row.dropdown || {}
                const _calculation = _str_row.calculation || {}
                const _noteditables = _str_row.noteditables || []
                table_header.forEach(fieldKey => {
                    // dropdown, calculation, noteditables는 subs 답변 제외
                    if (!_dropdown[fieldKey] && !_calculation[fieldKey] && !_noteditables.includes(fieldKey)) {
                        const [fieldKey_ca, fieldKey_ea] = [`${fieldKey}_ca`, `${fieldKey}_ea`]
                        if (_str_row[fieldKey_ea]) {
                            _str_row[fieldKey] = _str_row[fieldKey_ea]
                        } else if(sub[fieldKey_ca]) {
                            _str_row[fieldKey] = _str_row[fieldKey_ca]
                        }
                        if (_str_row[fieldKey_ea]) delete _str_row[fieldKey_ea]
                        if (_str_row[fieldKey_ca]) delete _str_row[fieldKey_ca]
                    }
                })
            }

            _structure.push(_str_row)
            return _structure
        }, [])
    }

    return {
        sub_init_id, sub_id,
        company_id, company_name, campaign_id,
        sub_code, sub_type,
        sub_name, sub_name_e, sub_name_c,
        sub_description, sub_description_e, sub_description_c,
        sub_info, sub_info_e, sub_info_c,
        sub_condition,
        sub_data_header, sub_data_contents,
        sub_priority, sub_child, sub_parent,
        tags, risk, has_pipeline, label
    }
}

export const generateSubcomponentInitData = function () {
    const _init_data  = {
        subs_init_id: null,
        sub_code: null,
        sub_type: null,
        sub_name: null,
        sub_name_e: null,
        sub_name_c: null,
        sub_description: null,
        sub_description_e: null,
        sub_description_c: null,
        sub_info: null,
        sub_info_e: null,
        sub_info_c: null,
        sub_data_header: {},
        sub_data_contents: {
            structure:[
                {text: '예', value: '예'},
                {text: '아니오', value: '아니오'}
            ],
            result: []
        },
        sub_child: [],
        sub_parent: '',
        sub_condition: {},
        sub_priority: '',
        risk: false,
        tags: []
    }
    
    return _init_data
}

export const computeTranslationLanguage = function (titleSet) {
    let _title = typeof titleSet === 'string' ? titleSet : Object.keys(titleSet)[0]
    return _title.includes('_ca') ? '중문' : _title.includes('_ea') ? '영문' : '국문'
}


export const isFieldEmpty = function (val) {
    return Array.isArray(val)
        ? !val.length
        : val === null || typeof val === 'undefined'
            ? true
            : typeof val === 'object' && !Array.isArray(val)
                ? !Object.keys(val).length
                : val.toString().trim() === ''
}
